import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import {
	AdvancedSearchFilterSourceEnum,
	TriggeredFromEnum,
	mapLocationToAdvancedSearchEnum,
} from 'functions/mappers/AdvancedSearch/mapLocationToAdvancedSearchEnum';
import { Optional } from 'functions/promiseExtensions';

export function callApi(
	searchTerm: string,
	showOnlyDeleted: boolean,
	cultureCode?: string
): Promise<Optional<ResponseIngredient[]>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Ingredient/StartingWith`;
	const params: Parameter = {
		SearchTerm: searchTerm,
		ShowOnlyDeleted: showOnlyDeleted,
	};
	if (mapLocationToAdvancedSearchEnum(TriggeredFromEnum.Ingredient)) {
		params.AdvancedSearchFilterSource = mapLocationToAdvancedSearchEnum(
			TriggeredFromEnum.Ingredient
		);
	}
	const config = cultureCode
		? {
				params: params,
				headers: { 'Accept-Language': cultureCode },
		  }
		: {
				params: params,
		  };
	return axios.get(url, config).toOptionalMapped((x) => x.data.ingredients);
}

interface Parameter {
	SearchTerm: string;
	ShowOnlyDeleted: boolean;
	AdvancedSearchFilterSource?: AdvancedSearchFilterSourceEnum | false;
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	ingredients: ResponseIngredient[];
};

export type ResponseIngredient = {
	id: string;
	description: string;
};
